module.exports = __webpack_public_path__ + "img/geo_data_terrain.75c7d0d5.svg";